<script>
  import FormItem from '@components/forms/form-item.svelte'
  import { get } from '@rails/request.js'
  import { onMount } from 'svelte'

  let { value = $bindable(), label = "Contributor", itemProps = {} } = $props()

  let loading = $state(false)
  let error = $state(null)
  let contributors = $state([])

  async function fetchContributors() {
    try {
      loading = true
      error = null
      const response = await get('/api/v1/contributors')
      if (response.ok) {
        const json = await response.json
        contributors = json.data
      } else {
        error = response.statusText
      }
    } catch (error) {
      error = error.message
    } finally {
      loading = false
    }
  }

  onMount(async () => {
    await fetchContributors()
  })

</script>

<FormItem bind:value {label} type="select" 
  options={contributors} 
  labelKey="name"
  valueKey="id"
  blank={true}
  disabled={loading}
  error={error}
  {...itemProps} />
